export default "__VITE_ASSET__BgIaB0GX__"